import { find, cloneDeep, findIndex } from 'lodash';
import {
    PROFILE_TAB_OVERVIEW_FETCH_REQUEST,
    PROFILE_TAB_OVERVIEW_FETCH_SUCCESS,
    PROFILE_TAB_OVERVIEW_FETCH_FAILURE,
    PROFILE_TAB_RESULTS_FETCH_REQUEST,
    PROFILE_TAB_RESULTS_FETCH_SUCCESS,
    PROFILE_TAB_RESULTS_FETCH_FAILURE,
    PROFILE_TAB_EVENTS_FETCH_REQUEST,
    PROFILE_TAB_EVENTS_FETCH_SUCCESS,
    PROFILE_TAB_EVENTS_FETCH_FAILURE,
    PROFILE_TAB_CLUBS_FETCH_REQUEST,
    PROFILE_TAB_CLUBS_FETCH_SUCCESS,
    PROFILE_TAB_CLUBS_FETCH_FAILURE,
    PROFILE_TAB_STATS_FETCH_REQUEST,
    PROFILE_TAB_STATS_FETCH_SUCCESS,
    PROFILE_TAB_STATS_FETCH_FAILURE,
    PROFILE_TAB_CLEAR_ALL_DATA,
    PROFILE_TAB_HAS_CHANGED_PROFILES,
} from '../actions/actionTypes/profile-tab-action-types';

const _ = { find, cloneDeep, findIndex };

const initialState = {
    hasChangedProfiles: false,
    overview: {
        isLoading: false,
        error: null,
        data: null,
    },
    results: {
        isLoading: false,
        error: null,
        data: null,
    },
    events: {
        isLoading: false,
        error: null,
        data: null,
    },
    clubs: {
        isLoading: false,
        error: null,
        data: {
            clubs: null,
            recentClubs: null,
        },
    },
    stats: {
        isLoading: false,
        error: null,
        data: null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_TAB_OVERVIEW_FETCH_REQUEST:
            return {
                ...state,
                overview: {
                    ...state.overview,
                    isLoading: true,
                },
            };
        case PROFILE_TAB_OVERVIEW_FETCH_SUCCESS:
            return {
                ...state,
                overview: {
                    isLoading: false,
                    error: null,
                    data: action.payload,
                },
            };
        case PROFILE_TAB_OVERVIEW_FETCH_FAILURE:
            return {
                ...state,
                overview: {
                    isLoading: false,
                    error: action.payload,
                    data: null,
                },
            };
        // RESULTS
        case PROFILE_TAB_RESULTS_FETCH_REQUEST:
            return {
                ...state,
                results: {
                    ...state.results,
                    isLoading: true,
                },
            };
        case PROFILE_TAB_RESULTS_FETCH_SUCCESS:
            return {
                ...state,
                results: {
                    isLoading: false,
                    error: null,
                    data: action.payload,
                },
            };
        case PROFILE_TAB_RESULTS_FETCH_FAILURE:
            return {
                ...state,
                results: {
                    isLoading: false,
                    error: action.payload,
                    data: null,
                },
            };
        // EVENTS
        case PROFILE_TAB_EVENTS_FETCH_REQUEST:
            return {
                ...state,
                events: {
                    ...state.events,
                    isLoading: true,
                },
            };
        case PROFILE_TAB_EVENTS_FETCH_SUCCESS:
            return {
                ...state,
                events: {
                    isLoading: false,
                    error: null,
                    data: action.payload,
                },
            };
        case PROFILE_TAB_EVENTS_FETCH_FAILURE:
            return {
                ...state,
                events: {
                    isLoading: false,
                    error: action.payload,
                    data: null,
                },
            };
        // CLUBS
        case PROFILE_TAB_CLUBS_FETCH_REQUEST:
            return {
                ...state,
                clubs: {
                    ...state.clubs,
                    isLoading: true,
                },
            };
        case PROFILE_TAB_CLUBS_FETCH_SUCCESS: {
            const { clubs, recentClubs } = action.payload;
            return {
                ...state,
                clubs: {
                    isLoading: false,
                    error: null,
                    data: {
                        clubs,
                        recentClubs,
                    },
                },
            };
        }
        case PROFILE_TAB_CLUBS_FETCH_FAILURE:
            return {
                ...state,
                clubs: {
                    isLoading: false,
                    error: action.payload,
                    data: null,
                },
            };
        // STATS
        case PROFILE_TAB_STATS_FETCH_REQUEST:
            return {
                ...state,
                stats: {
                    ...state.stats,
                    isLoading: true,
                },
            };
        case PROFILE_TAB_STATS_FETCH_SUCCESS:
            return {
                ...state,
                stats: {
                    isLoading: false,
                    error: null,
                    data: action.payload,
                },
            };
        case PROFILE_TAB_STATS_FETCH_FAILURE:
            return {
                ...state,
                stats: {
                    isLoading: false,
                    error: action.payload,
                    data: null,
                },
            };
        case PROFILE_TAB_CLEAR_ALL_DATA:
            return { ...initialState };
        case PROFILE_TAB_HAS_CHANGED_PROFILES: {
            const isProfileChange = action.payload;
            if (isProfileChange) {
                return {
                    ...initialState,
                    hasChangedProfiles: action.payload,
                };
            }
            return {
                ...state,
                hasChangedProfiles: action.payload,
            };
        }

        case 'POST_SCORE:DELETE_SCORE_SUCCESS': {
            const { resultId } = action.data;
            const results = _.cloneDeep(state.results?.data) || [];
            const updatedOverviewResults = _.cloneDeep(state.overview?.data?.results) || [];
            let resultIndex = -1;
            const recentResultIndex = updatedOverviewResults ? _.findIndex(updatedOverviewResults, { id: resultId }) : -1;

            if (results?.events?.length > 0) {
                results.events.forEach((event) => {
                    if (event?.draws?.results?.length > 0) {
                        resultIndex = _.findIndex(event.draws.results, { id: resultId });
                        if (resultIndex !== -1) {
                            event.draws.results.splice(resultIndex, 1);
                        }
                    }
                    if (event?.results?.length > 0) {
                        resultIndex = _.findIndex(event.results, { id: resultId });
                        if (resultIndex !== -1) {
                            event.results.splice(resultIndex, 1);
                        }
                    }
                });
            }
            if (updatedOverviewResults && recentResultIndex !== -1) {
                updatedOverviewResults.splice(recentResultIndex, 1);
            }

            return {
                ...state,
                results: {
                    ...state.results,
                    data: results,
                },
                overview: {
                    ...state.overview,
                    data: {
                        ...state.overview.data,
                        results: updatedOverviewResults,
                    },
                },
            };
        }
        case 'POST_SCORE:ACCEPT_REJECT_SCORE_SUCCESS': {
            const { resultId } = action.data;
            const { result } = action.data;
            const results = _.cloneDeep(state.results?.data) || [];
            const updatedOverviewResults = _.cloneDeep(state.overview?.data?.results) || [];
            let resultIndex = -1;
            const recentResultIndex = updatedOverviewResults ? _.findIndex(updatedOverviewResults, { id: resultId }) : -1;

            if (results?.events?.length > 0) {
                results.events.forEach((event) => {
                    if (event?.draws?.results?.length > 0) {
                        resultIndex = _.findIndex(event.draws.results, { id: resultId });
                        if (resultIndex !== -1) {
                            event.draws.results.splice(resultIndex, 1, result);
                        }
                    }
                    if (event?.results?.length > 0) {
                        resultIndex = _.findIndex(event.results, { id: resultId });
                        if (resultIndex !== -1) {
                            event.results.splice(resultIndex, 1, result);
                        }
                    }
                });
            }
            if (updatedOverviewResults && recentResultIndex !== -1) {
                updatedOverviewResults.splice(recentResultIndex, 1, result);
            }

            return {
                ...state,
                results: {
                    ...state.results,
                    data: results,
                },
                overview: {
                    ...state.overview,
                    data: {
                        ...state.overview.data,
                        results: updatedOverviewResults,
                    },
                },
            };
        }
        default:
            return state;
    }
};
